<!-- Research Plans - 研究方向 -->
<template>
  <div class="info-research">
    <h1>Research Plans</h1>
    <div class="dis-48">
      <div class="dis-12">1. Have you encountered any specific areas or topics of research that you find particularly exciting? How and why are those exciting to you?</div>
      <div>
        <pre>{{info.interestedTask}}</pre>
      </div>
    </div>
    <div class="dis-48">
      <div class="dis-12">2. Are there any specific research topics / issues that you want to pursue / help tackle?</div>
      <div>
        <pre>{{info.captureTask}}</pre>
      </div>
    </div>
    <div class="dis-48">
      <div class="dis-12">3. In the research labs you've worked for, have you previously met with students who were applying for graduate studies abroad? What were their application results?</div>
      <div>
        <pre>{{info.xzxjqk}}</pre>
      </div>
    </div>
  </div>
</template>

<script>
import { infoQueryDirection } from '@/api/mentee'
export default {
  name: 'mentee-info-research',
  components: {},
  data () {
    return {
      info: {}
    }
  },
  computed: {},
  mounted () {
    this.getInfo()
  },
  methods: {
    getInfo () {
      let param = {
        num: this.$route.params.id
      }
      infoQueryDirection(param).then(res => {
        let data = res.data.model || {}
        this.info = Object.assign({}, data)
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
